import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaInformacionConfiguracionEditarConceptosComponent {
  data = undefined
  acumulado = undefined

  $onInit () {
    this.totalizar()
  }

  seleccionar () {
    this.data.forEach((item) => (item.activo = this.todos))
  }

  totalizar () {
    this.todos = this.data.every((item) => item.activo)
  }
}

module.component('nominasNominaInformacionConfiguracionEditarConceptos', {
  controller: NominasNominaInformacionConfiguracionEditarConceptosComponent,
  template,
  bindings: {
    data: '<',
    acumulado: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/configuracion/editar/conceptos/component.js